import Vue from 'vue';
import Vuex from 'vuex';
import toolsUtils from "../common/toolsUtils.js"
import api from "../common/request.js"
import { Message } from 'element-ui';
import CryptoJS from "crypto-js"
import router from "../router/index.js"

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        info: "store init success",
        userInfos: {},
        userToken: "",
        isLogin: false,
        navBarActivedIndex: 0,

    },
    mutations: {
        //保存用户信息
        saveLoginInfo(state, userInfoObj) {
            state.userInfos = {}; //清空，已因为有时候无法清空对象属性值;
            state.userToken = "";
            state.isLogin = false;

            let user_token = toolsUtils.getCookiesSync("user_token");
            let user_info = null;
            if(toolsUtils.getCookiesSync("user_info")){
                user_info = CryptoJS.AES.decrypt(toolsUtils.getCookiesSync("user_info"), 'jfgas12444#####').toString(CryptoJS.enc.Utf8); 
                user_info = JSON.parse(user_info);
            }
            

            if (!toolsUtils.isObjEmpty(userInfoObj) || !toolsUtils.isObjEmpty(user_info)) {
                state.isLogin = true;
                state.userInfos = {...user_info, ...userInfoObj }
            }

            if (!toolsUtils.isObjEmpty(user_token)) {
                state.isLogin = true;
                state.userToken = user_token
            }


        },
        //用户退出登录
        logoutUser(state) {
            state.userInfos = {}; //清空，已因为有时候无法清空对象属性值;
            state.userToken = "";
            state.isLogin = false;
            toolsUtils.removeAllStorage();
            toolsUtils.removeCookiesSync("user_token");
            toolsUtils.removeCookiesSync("user_info");

        },
        changeStoreNavBarIndex(state) {
            let index = toolsUtils.getStorageSync("navBarActivedIndex");
            if (!toolsUtils.isStrEmpty(index)) {
                state.navBarActivedIndex = index;
            } else {
                state.navBarActivedIndex = 0;
            }

        }
    },
    actions: {
        //获取学生或者教练的信息
        //role:0学生    role:1教练
        async getUserInfo({ state, getters, commit }, params) {

            commit("saveLoginInfo");

            if (state.isLogin) {

                if (!getters.getUserToken || toolsUtils.isObjEmpty(state.userInfos)) {
                    Message({
                        type: 'error',
                        message: "用户信息错误，请重新登录"
                    });
                    commit("logoutUser");
                    router.replace({
                        name: "login"
                    })
                    return;
                }
                //获取用户信息
                let res = null;

                if(state.userInfos.role == "0"){
                    res = await api.get("/web/frontUser/student/info", {
                        headers: { //头部参数
                            frontUserToken: getters.getUserToken
                        }
                    })
                }else { 
                    res = await api.get("/web/frontUser/teacher/info", {
                        headers: { //头部参数
                            frontUserToken: getters.getUserToken
                        }
                    })
                }

                if (res.code == 200) {
                    state.userInfos = {...state.userInfos,...res.data};

                } else {

                    Message({
                        type: 'error',
                        message: res.msg
                    });

                    let t = setTimeout(() => {
                        Message({
                            type: 'error',
                            message: "请重新登录"
                        });

                        clearTimeout(t);
                        commit("logoutUser");
                        router.replace({
                            name: "login"
                        })

                    }, 1000);


                }


            }

        }
    },
    getters: {
        getUserToken(state) {
            let tmp = CryptoJS.AES.decrypt(state.userToken, 'jfgas12444#####').toString(CryptoJS.enc.Utf8)
            return tmp;
        }
    }


});


export default store